// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3rl0e","rootCenter":"LoadMoreObserver_rootCenter__3BORe","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__26YbQ"};